<template>
    <Link :href="href" :class="classes">
        <slot />
    </Link>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3';

    export default {
        components: {
            Link,
        },
        props: ['href', 'navRoute', 'activeRoute'],
        data() {
            return {
                defaultClasses : 'inline-flex items-center px-1 pt-1 border-b-2 text-sm font-bold text-blue-dark-500 leading-5 focus:outline-none transition',
            }
        },

        computed: {
            classes() {
                return (this.navRoute == this.activeRoute)
                    ? this.defaultClasses + ' border-yellow-500'
                    : this.defaultClasses + ' border-transparent hover:border-yellow-500'
            }
        }
    }
</script>
